// Main exports for @buni.ai/chatbot-vue

export { useBuniChat } from './composables/useBuniChat';

// Export Vue component
import BuniChatWidgetComponent from './components/BuniChatWidget.vue';
export const BuniChatWidget = BuniChatWidgetComponent;

// Create a Vue plugin for easy installation
import type { App } from 'vue';

export const BuniChatPlugin = {
  install(app: App) {
    app.component('BuniChatWidget', BuniChatWidgetComponent);
  }
};

// Re-export core types for convenience
export type {
  BuniChatConfig,
  BuniChatOptions,
  BuniChatState,
  CustomerData,
  SessionVariables,
  BuniChatAPI,
  BuniChatEvents
} from '@buni.ai/chatbot-core';

// Export core widget class for manual use
export { BuniChatWidget as BuniChatWidgetCore, createBuniChatWidget } from '@buni.ai/chatbot-core';
